export default {
  props: {
    optionFormat: {
      type: Object,
      default: () => ({
        label: 'label',
        value: 'value'
      })
    },
    getOptionsFn: {
      type: Object,
      default: () => ({
        province: () => {},
        city: () => {},
        school: () => {}
      })
    }
  },
  data() {
    return {
      open: false,
      provinceOptions: [],
      schoolOptions: [],
      schoolOptionsSource: [],
      formData: {}
    };
  },
  methods: {
    formatOptions(data = this.schoolOptionsSource) {
      this.schoolOptions = data.map(({ id, name }) => ({ id, name }));
    },
    filterOptions() {
      const data =
        this.formData.pinyin !== -1
          ? this.schoolOptionsSource.filter(({ pinyin }) =>
              new RegExp(`^${this.formData.pinyin}`).test(pinyin)
            )
          : this.schoolOptionsSource;
      const result = this.formData.keyword
        ? data.filter(({ name }) =>
            new RegExp(this.formData.keyword).test(name)
          )
        : data;
      this.formatOptions(result);
    }
  }
};
